import { gettext } from '@eventbrite/i18n';
import React from 'react';

interface LocationIconProps {
    className?: string;
    'aria-label'?: string;
}

export const LocationIcon: React.FC<LocationIconProps> = ({
    className,
    'aria-label': ariaLabel,
}) => (
    <svg
        className={className}
        aria-label={ariaLabel || gettext('Location').toString()}
        role="img"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M8 8.66797C9.10457 8.66797 10 7.77254 10 6.66797C10 5.5634 9.10457 4.66797 8 4.66797C6.89543 4.66797 6 5.5634 6 6.66797C6 7.77254 6.89543 8.66797 8 8.66797Z" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 6.66797C14 10.668 8 15.3346 8 15.3346C8 15.3346 2 10.668 2 6.66797C2 3.0013 4.68629 0.667969 8 0.667969C11.3137 0.667969 14 3.0013 14 6.66797ZM12.6667 6.66797C12.6667 7.34885 12.4052 8.15861 11.9004 9.05595C11.4026 9.94098 10.7207 10.8185 10.0089 11.6093C9.30105 12.3959 8.58882 13.069 8.05168 13.5464L8 13.5922L7.94832 13.5464C7.41118 13.069 6.69895 12.3959 5.99106 11.6093C5.2793 10.8185 4.59743 9.94098 4.0996 9.05595C3.59485 8.15861 3.33333 7.34885 3.33333 6.66797C3.33333 3.78927 5.37 2.0013 8 2.0013C10.63 2.0013 12.6667 3.78927 12.6667 6.66797Z"
        />
    </svg>
);
